module.exports = __webpack_public_path__ + "static/media/girl_talking.d1f885e4.gif";